module.exports = __webpack_public_path__ + "static/media/Flame over circle.dded8f17.png";